import { mediaData } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          精彩片段
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          未删减版镜头解析与深度观影内容
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaData.slice(0, 3).map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group bg-background-100 border border-background-200/70 hover:border-primary-400/30 rounded-lg overflow-hidden transition-colors cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-12 h-12 rounded-full bg-primary-500/80 flex items-center justify-center">
                    <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
                  </span>
                </div>
                <div className="absolute bottom-2 right-2 text-xs text-background-50 bg-black/60 px-1.5 py-0.5 rounded whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-400 transition-colors mb-1.5">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-2">{item.desc}</p>
                <span className="text-xs text-foreground-400">
                  <i className="ri-eye-line mr-1"></i>
                  {item.views} 次观看
                </span>
              </div>
            </a>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {mediaData.slice(3).map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group bg-background-100 border border-background-200/70 hover:border-primary-400/30 rounded-lg overflow-hidden transition-colors cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="relative aspect-video sm:w-48 flex-shrink-0 overflow-hidden bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-10 h-10 rounded-full bg-primary-500/80 flex items-center justify-center">
                    <i className="ri-play-fill text-background-50 text-lg ml-0.5"></i>
                  </span>
                </div>
                <div className="absolute bottom-2 right-2 text-xs text-background-50 bg-black/60 px-1.5 py-0.5 rounded whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4 flex-1">
                <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-400 transition-colors mb-1.5">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-2">{item.desc}</p>
                <span className="text-xs text-foreground-400">
                  <i className="ri-eye-line mr-1"></i>
                  {item.views} 次观看
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}